import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved || 'light';
  });

  useEffect(() => {
    localStorage.setItem('theme', theme);
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Forces light theme while a forced-light page (auth/signup) is mounted
export const useForceLightTheme = () => {
  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('dark');
    root.classList.add('light');
    return () => {
      if (localStorage.getItem('theme') === 'dark') {
        root.classList.remove('light');
        root.classList.add('dark');
      }
    };
  }, []);
};

export const useTheme = () => {
  const context = useContext(ThemeContext);if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
